<div class="container">
  <div class="container-fluid py-5">
    <div class="container py-5">
      <h1
        class="display-4 text-uppercase text-center mb-5"
        style="color: #252525"
      >
        Nuestro Equipo
      </h1>
      <div class="row">
        @for (item of teamMembers; track $index) {
        <div class="col-md-6">
          <div class="team-item rounded overflow-hidden">
            <div class="position-relative">
              <img
                class="img-fluid w-100"
                [src]="item.image"
                [alt]="item.name"
              />
              <div class="team-overlay">
                <div class="d-flex align-items-center justify-content-start">
                  <p style="color: #fbd541" class="mx-3">
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </div>
            <div class="bg-light text-center p-4">
              <h4 class="text-uppercase" style="color: #444440">
                {{ item.name }}
              </h4>
              <p class="m-0" style="color: #444440">{{ item.position1 }}</p>
              <p class="m-0" style="color: #444440">{{ item.position2 }}</p>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
